module.exports = __webpack_public_path__ + "static/media/AreYouAVeteran.9ce96acd.svg";